module.exports = __webpack_public_path__ + "media/images/icons/results-767ac4b4cd42ea06145a108ee8605797.svg";